import { render, staticRenderFns } from "./ImportStockIn.vue?vue&type=template&id=7063daee&scoped=true&"
import script from "./ImportStockIn.vue?vue&type=script&lang=js&"
export * from "./ImportStockIn.vue?vue&type=script&lang=js&"
import style0 from "./ImportStockIn.vue?vue&type=style&index=0&id=7063daee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063daee",
  null
  
)

export default component.exports